export default "__VITE_ASSET__C5Wm1u4c__"